import styled, { keyframes } from 'styled-components'
import { tokens } from 'styling/tokens'

export const Wrapper = styled.div<{ width?: string }>`
  position: relative;
  width: ${(props) => props.width ?? 'auto'};
`

export const Display = styled.div<{ open?: boolean; hasValue?: boolean; active?: boolean }>`
  margin: 0.2rem 0;

  width: 100%;
  min-width: 180px;
  height: 40px;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 1rem;
  cursor: pointer;
  user-select: none;
  transition: 0.2s ease;
  border-radius: ${tokens.radius.control};
  border: 1px solid
    ${(props) =>
      props.active ? tokens.accent.base : props.hasValue ? tokens.border.strong : tokens.border.hairline};
  background-color: ${tokens.surface.inset};
  color: ${tokens.text.primary};

  &:hover {
    border: 1px solid ${tokens.border.strong};
  }
`

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(-8px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`

export const Popup = styled.div<{ fixed?: boolean; rightAlign?: boolean }>`
  position: ${(p) => (p.fixed ? 'fixed' : 'absolute')};
  top: 100%;
  left: ${(p) => (p.rightAlign ? 'auto' : '0')};
  right: ${(p) => (p.rightAlign ? '0' : 'auto')};
  z-index: 99999999999;
  padding: 0.6rem;
  border-radius: ${tokens.radius.card};
  animation: ${fadeInUp} 0.18s ease-out;
  background-color: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  box-shadow: ${tokens.shadow.card};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 0.25rem 0.5rem;
`

export const NavButton = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: transparent;
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.secondary};
  cursor: pointer;
  transition: 0.15s ease;
  &:hover {
    background: ${tokens.accent.base};
    color: ${tokens.accent.ink};
  }
`

export const Selects = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  select {
    height: 30px;
    border-radius: 8px;
    padding: 0 0.5rem;
    border: 1px solid ${tokens.border.hairline};
    background-color: ${tokens.surface.inset};
    color: ${tokens.text.primary};

    /* Style the native options list so text remains visible on Windows */
    option {
      color: black;
    }
  }
`

export const WeekdaysRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.25rem;
  padding: 0.25rem 0.25rem 0.3rem;
  opacity: 0.8;
  font-size: 12px;
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.25rem;
`

export const DayCell = styled.button<{
  isToday?: boolean
  isSelected?: boolean
  inRange?: boolean
  isDisabled?: boolean
  isOutside?: boolean
}>`
  height: 36px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: ${(p) => (p.inRange ? tokens.accent.soft : 'transparent')};
  color: ${(p) => (p.isOutside ? tokens.text.muted : tokens.text.primary)};
  cursor: ${(p) => (p.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${(p) => (p.isDisabled ? 0.5 : 1)};
  transition: 0.15s ease;
  position: relative;

  &:hover {
    transform: translateY(-1px);
  }

  ${(p) =>
    p.isSelected &&
    `
    background: ${tokens.accent.base};
    color: ${tokens.accent.ink};
  `}

  ${(p) =>
    p.isToday &&
    !p.isSelected &&
    `
    border-color: ${tokens.accent.base};
  `}
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 0.5rem;
`

export const TimePickerSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.75rem 0.25rem 0.25rem;
  border-top: 1px solid ${tokens.border.hairline};
  margin-top: 0.5rem;
`

export const TimePickerGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`

export const TimePickerLabel = styled.label`
  font-size: 12px;
  color: ${tokens.text.muted};
  font-weight: 500;
`

export const TimePickerSelect = styled.select`
  height: 32px;
  min-width: 60px;
  border-radius: 6px;
  padding: 0 0.5rem;
  border: 1px solid ${tokens.border.hairline};
  background-color: ${tokens.surface.inset};
  color: ${tokens.text.primary};
  text-align: center;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${tokens.accent.base};
  }
`
